module.exports = __webpack_public_path__ + "assets/logo.f3103225.svg";